var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('crud-data-table',_vm._b({attrs:{"no-remove":"","no-search":"","no-actions":!_vm.$can('VIEW_DETAIL_PURCHASE_INVOICE')},on:{"detail":_vm.submitDetail}},'crud-data-table',_vm.tableProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }